// test547
(547 && 0);
